import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faSearch, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Retention.css'
import { Tooltip } from 'react-tooltip';
import GoCast from '../../Images/GoCast.png'
const Retention = () => {

    // Loading GIF
    const [isLoading, setIsLoading] = useState(false);
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);
    // Search-bar
    const [searchOpen, setSearchOpen] = useState(false);

    // Search Toggle
    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }
    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }
    //        API CODE
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = 'https://77.92.189.102/IIPrecastVerticalDemo/api/v1/BaqSvc/IIT_MiscChargeData(PRECAST)'; // Adjust the URL as needed

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Check if data is an object and contains the 'value' property which is an array
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                setIsLoading(false); // Load GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
            setIsLoading(true); // Load GIF
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = apiData.slice(startIndex, endIndex);

        return currentItems.map((item, index) => (
            <tr key={index}>
                <td>{item.MiscChrgtax_MiscCode}</td>
                <td>{item.InvcHeadTax_InvoiceNum}</td>
                <td>{item.ProjectTax_ProjectID}</td>
                <td>{item.ProjectTax_Description}</td>
                <td>{item.OrderDtl1Tax_OrderNum}</td>
                <td>{item.InvcHeadTax_InvoiceDate}</td>
                <td>{item.InvcHeadTax_ApplyDate}</td>
                <td>{item.Customertax_Name}</td>
                <td>{item.InvcMisc_InvoiceNum}</td>
                <td>{item.InvcHead_Posted}</td>
            </tr>
        ));
    };
    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    return (
        <div className='card retentionTable'>
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className="card-header-retention">
                <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                    <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                </button>
                {/* <h2 className='panel-title-retention'>Retention Dashboard</h2> */}
                <div className='ret-id-container'>
                    <input type='text' placeholder=' Charge ID' className='Containeridinput' />
                    <FontAwesomeIcon icon={faSearch} className='searchicon' />

                </div>
                <div className='ctrl-btns-rebar'>
                    <button type="button" className="search-icon" onClick={toggleSearch}>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                    <Tooltip
                        anchorSelect=".search-icon"
                        content="Advanced Search"
                        place='bottom'
                    />
                    {/* New button to toggle table visibility */}

                    {/* Existing search div */}
                    <div className={`main-search-bar ${searchOpen ? 'open' : ''}`} id="searchBar" style={{ height: '650px', overflowY: 'scroll' }}>
                        {/* Search form */}
                        <form className="search-filter">
                            <h3 className="search-title">Search Filter <FontAwesomeIcon icon={faSearch} /></h3>
                            <input type="text" placeholder="Charge ID" name="filter1" />
                            <input type="text" placeholder="Invoice" name="filter2" />
                            <input type="text" placeholder="Project ID=" name="filter3" />
                            <input type="text" placeholder="Description=" name="filter4" />
                            <input type="text" placeholder="Sales Order=" name="filter5" />
                            <input type="date" placeholder="Invoice Date" name="filter6" />
                            <input type="date" placeholder="Apply Date" name="filter7" />
                            <input type="text" placeholder="Customer ID= " name="filter8" />
                            <input type="text" placeholder="Customer Name >= " name="filter9" />
                            <button type="submit">Search</button>
                            <button type="reset" onClick={toggleSearch}>Cancel</button>
                        </form>
                    </div>
                </div>
            </div>
            {/* Conditionally render the table */}
            {tableVisible && (
                <div className="card-body">
                    <div class="table-responsive">
                        <table className="table table-bordered">
                            {/* Table content */}
                            <thead className='table-primary'>
                                <tr className='bg-primary text-white'>
                                    <th>Charge ID</th>
                                    <th>Invoice</th>
                                    <th>Project ID</th>
                                    <th>Description</th>
                                    <th>Sales Order</th>
                                    <th>Inv Date</th>
                                    <th>Apply Date</th>
                                    <th>Name</th>
                                    <th>Ref Re Inv</th>
                                    <th>Posted</th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderTableRows()}
                            </tbody>
                        </table>
                    </div>
                    <div className="pagination">
                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Retention;

